var React = require('react');

function ArrowSwirlUp40x80 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Size=40x80, Invert=off, Flip=off","clipPath":"url(#clip0_6934_26241)","stroke":"currentColor","strokeWidth":"3","strokeMiterlimit":"10","key":0},[React.createElement("path",{"id":"Vector","d":"M37.933 8.43L24.81 2.195l-2.06.707-5.461 12.587","strokeLinecap":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M23.577 2.745s17.82 36.176.67 46.09c-14.372 8.301-24.219-2.15-21.066-9.9 3.355-8.273 15.09-9.122 20.88.283 6.819 11.215 4.026 39.258 4.026 39.258","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_6934_26241"},React.createElement("path",{"fill":"#fff","d":"M0 0h40v80H0z"})))]);
}

ArrowSwirlUp40x80.defaultProps = {"width":"40","height":"80","viewBox":"0 0 40 80","fill":"none"};

module.exports = ArrowSwirlUp40x80;

ArrowSwirlUp40x80.default = ArrowSwirlUp40x80;
